import React, { Component } from 'react';

export default class About extends Component {
  componentDidMount() {
    document.title = 'About ForeignSix | Incident Response Orchestration';
    const canon = document.querySelector('link[rel="canonical"]');
    if (canon) canon.setAttribute('href', 'https://foreignsix.com/about');
  }

  componentWillUnmount() {
    document.title = 'ForeignSix | Incident Response Orchestration';
    const canon = document.querySelector('link[rel="canonical"]');
    if (canon) canon.setAttribute('href', 'https://foreignsix.com/');
  }

  render() {
    return (
      <main className="content">
        <section className="card mb-4 shadow-lg text-light" style={{ backgroundColor: 'rgba(33, 37, 41, 0.45)', backdropFilter: 'blur(4px)', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
          <div className="card-body">
            <h1 className="fs-2">About ForeignSix</h1>
            <p className="text-secondary">ForeignSix LLC is an American technology company incorporated in the State of Delaware. We build software for cybersecurity professionals, incident responders, and digital forensic analysts who need to operate at scale and speed, without compromising on evidence integrity or data sovereignty.</p>
          </div>
        </section>

        <section className="container-fluid p-0 mt-4">

          <article className="card mb-4 shadow-lg text-light" style={{ backgroundColor: 'rgba(33, 37, 41, 0.45)', backdropFilter: 'blur(4px)', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
            <header className="card-header border-bottom border-secondary">
              <h2 className="fs-5 mb-0">Our Mission</h2>
            </header>
            <div className="card-body">
              <p>Digital forensic acquisition should not require a plane ticket. In a world where infrastructure is distributed and incidents happen around the clock, the old model of shipping hard drives and flying analysts across borders is a liability, both in time and in chain-of-custody risk.</p>
              <p className="mb-0">Our mission is to give security teams the ability to conduct remote, verifiable forensic acquisitions from any machine, anywhere in the world, over a secure private network, and to do so without ever exposing their evidence data to a third party.</p>
            </div>
          </article>

          <article className="card mb-4 shadow-lg text-light" style={{ backgroundColor: 'rgba(13, 110, 253, 0.08)', backdropFilter: 'blur(4px)', border: '1px solid rgba(13, 110, 253, 0.35)' }}>
            <header className="card-header border-bottom" style={{ borderColor: 'rgba(13,110,253,0.35)' }}>
              <h2 className="fs-5 mb-0 text-info">What We Build</h2>
            </header>
            <div className="card-body">
              <p><strong>ForeignSix IR</strong> is our flagship product: a self-hosted incident response orchestration platform for remote forensic acquisition. It connects a fleet of lightweight agents running on Windows, Linux, and macOS endpoints to a central IR server that you deploy on your own infrastructure.</p>
              <p>Agents connect to the IR server automatically over a private, authenticated TLS tunnel: an encrypted outbound connection that works through NATs and firewalls with no VPN infrastructure to manage. Evidence data travels directly from agent to server, never through ForeignSix.</p>
              <p className="mb-0">Every completed acquisition generates a triple-hash checksum (MD5, SHA1, and SHA256) and a signed, court-ready Chain-of-Custody form, produced in real time as the disk is imaged.</p>
            </div>
          </article>

          <article className="card mb-4 shadow-lg text-light" style={{ backgroundColor: 'rgba(33, 37, 41, 0.45)', backdropFilter: 'blur(4px)', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
            <header className="card-header border-bottom border-secondary">
              <h2 className="fs-5 mb-0">Our Philosophy: Your Data, Your Infrastructure</h2>
            </header>
            <div className="card-body">
              <p>ForeignSix is not a cloud service. We deliberately chose a self-hosted model because we believe that forensic evidence (among the most sensitive data an organisation can hold) should never pass through infrastructure outside your control.</p>
              <p>When you subscribe, you receive a license key that unlocks our IR server binary. You run that binary on hardware you choose: your AWS account, your Azure tenant, your on-premises data centre, or an air-gapped lab network. We have no relay, no logging pipeline, and no storage of your evidence data. We are architecturally incapable of seeing what you acquire.</p>
              <p className="mb-0">This is not a marketing claim. It is a verifiable consequence of how the system is designed.</p>
            </div>
          </article>

          <article className="card mb-4 shadow-lg text-light" style={{ backgroundColor: 'rgba(33, 37, 41, 0.45)', backdropFilter: 'blur(4px)', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
            <header className="card-header border-bottom border-secondary">
              <h2 className="fs-5 mb-0">Company Details</h2>
            </header>
            <div className="card-body">
              <dl className="row mb-0">
                <dt className="col-sm-3 text-secondary">Legal name</dt>
                <dd className="col-sm-9">ForeignSix LLC</dd>

                <dt className="col-sm-3 text-secondary">Jurisdiction</dt>
                <dd className="col-sm-9">State of Delaware, United States of America</dd>

                <dt className="col-sm-3 text-secondary">Registered address</dt>
                <dd className="col-sm-9">254 Chapman Rd, Ste 208 #27600, Newark, Delaware 19702 US</dd>

                <dt className="col-sm-3 text-secondary">General enquiries</dt>
                <dd className="col-sm-9"><a href="mailto:info@foreignsix.com" className="text-info text-decoration-none">info@foreignsix.com</a></dd>

                <dt className="col-sm-3 text-secondary">Sales</dt>
                <dd className="col-sm-9"><a href="mailto:sales@foreignsix.com" className="text-info text-decoration-none">sales@foreignsix.com</a></dd>

                <dt className="col-sm-3 text-secondary">Support</dt>
                <dd className="col-sm-9 mb-0"><a href="mailto:support@foreignsix.com" className="text-info text-decoration-none">support@foreignsix.com</a></dd>
              </dl>
            </div>
          </article>

        </section>
      </main>
    );
  }
}
